import 'script-loader!./vendor/jquery.js'
import 'script-loader!./vendor/jquery-rebox.js'
import 'script-loader!./vendor/bootstrap/carousel.js'
import 'script-loader!./vendor/bootstrap/collapse.js'
import 'script-loader!./vendor/bootstrap/dropdown.js'
